import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RectSelectTypeComponent } from './components/rect-select-type/rect-select-type.component';
import { RectSelectComponent } from './components/rect-select/rect-select.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [RectSelectComponent, RectSelectTypeComponent],
  exports: [RectSelectComponent, RectSelectTypeComponent],
})
export class RectSelectModule {}
